import { Component, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Router } from '@angular/router';
import { Shell } from '../shell.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent {

  @ViewChild('refreshForm') refreshForm;

  isExpanded: boolean;
  master: boolean;

  navbar: any;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver, public authService: AuthService, private router: Router, public service: Shell) { }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnInit() {
    if(this.authService.isAuthenticated() && this.navbar === undefined){
      this.service.getmenu(this.authService.authorizationHeaderValue).subscribe((result:any) =>{
        this.navbar = result;
      })
    }
  }
  expandSection(item: any) {
    const expanded = item.Expanded;
    this.navbar.forEach(element => {
      element.Expanded = false;
    });
    item.Expanded = !expanded;
  }

}
